__webpack_require__.p = "https://assets.coubic.com/reserve/_next/";